import '../../styles/index.scss';
import '../../styles/pages/index.scss';
import InfiniteGrid from '../components/infinite-grid';

export default class Index {
  constructor() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();

    // Load images from Cloudinary API
    this.initWithCloudinaryImages();
  }

  async initWithCloudinaryImages() {
    try {
      // Fetch images from API
      const response = await fetch('/api/lookbook-images');
      const data = await response.json();

      if (!data.success || !data.images || data.images.length === 0) {
        return;
      }

      // Convert Cloudinary images to sources format with thumbnail support
      this.sources = data.images.map(img => ({
        src: img.url,  // Use Cloudinary URL directly
        thumbnail: img.thumbnail  // Low quality thumbnail for fast initial load
      }));

      // Generate grid-based layout with random positioning within cells
      const minSize = 1300;
      const maxSize = 1400;

      // Calculate grid dimensions
      const itemsPerRow = 10;  // 10 columns
      const itemsPerCol = Math.ceil(this.sources.length / itemsPerRow);

      // Cell size should be large enough for the biggest possible image with scale
      const maxPossibleSize = maxSize * 1.5;  // Account for 1.5x scale
      const maxPossibleHeight = maxPossibleSize * 1.5;  // Account for portrait ratio

      const cellWidth = maxPossibleSize * 1.55;  // Balanced spacing to prevent overlap
      const cellHeight = maxPossibleHeight * 1.25;  // Balanced spacing to prevent overlap

      const canvasWidth = cellWidth * itemsPerRow;
      const canvasHeight = cellHeight * itemsPerCol;

      // Shuffle and create grid positions
      this.data = this.sources.map((source, i) => {
        let randomSize = minSize + Math.random() * (maxSize - minSize);

        // 45% chance to scale up by 1.5x
        const shouldScale = Math.random() < 0.45;
        if (shouldScale) {
          randomSize *= 1.5;
        }

        // Calculate grid position
        const col = i % itemsPerRow;
        const row = Math.floor(i / itemsPerRow);

        // Calculate cell boundaries
        const cellX = col * cellWidth;
        const cellY = row * cellHeight;

        // Random position within cell with safety margin to prevent overlap
        const actualWidth = randomSize;
        const actualHeight = randomSize * 1.5;  // All images use portrait ratio

        // Add safety margin (5% of cell size) to prevent edge overlap while keeping images closer
        const safetyMargin = cellWidth * 0.05;

        const maxOffsetX = Math.max(0, cellWidth - actualWidth - safetyMargin * 2);
        const maxOffsetY = Math.max(0, cellHeight - actualHeight - safetyMargin * 2);

        const x = cellX + safetyMargin + Math.random() * maxOffsetX;
        const y = cellY + safetyMargin + Math.random() * maxOffsetY;

        return {
          x: x,
          y: y,
          w: randomSize,
          h: randomSize
        };
      });

      // Initialize InfiniteGrid
      new InfiniteGrid({
        el: document.querySelector('#images'),
        sources: this.sources,
        data: this.data,
        originalSize: {w: canvasWidth, h: canvasHeight},
      });
    } catch (error) {
      // Silent error handling
    }
  }

  resize() {
    document.documentElement.style.setProperty('--rvw', `${document.documentElement.clientWidth / 100}px`);
  }
}
window.addEventListener('load', () => {
  new Index();
});